import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { ViewportService } from '@app/core/_services/viewport.service'
import { MenuDrawerStateService } from '@app/navigation/services/menu-drawer-state.service'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faStar } from '@fortawesome/pro-light-svg-icons'
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-favorites-link',
    imports: [FaIconComponent, CommonModule, RouterModule, TooltipModule],
    templateUrl: './favorites-link.component.html',
    styleUrl: './favorites-link.component.scss',
})
export class FavoritesLinkComponent {
    public faStar = faStar
    public faStarSolid = faStarSolid
    public isHovered = false

    constructor(
        public menuDrawerStateService: MenuDrawerStateService,
        public viewportService: ViewportService,
    ) {}

    onMouseEnter() {
        if (!('ontouchstart' in window)) {
            this.isHovered = true
        }
    }

    onMouseLeave() {
        if (!('ontouchstart' in window)) {
            this.isHovered = false
        }
    }
}
